import React from 'react';
import PropTypes from 'prop-types';

const WeatherbysFamilyTree = ({ url }) => (
    <div className="hp-pedigree__familyTree hidden-sm-down">
        <h2 className="hp-weatherbys__title">Weatherbys Pedigree</h2>
        <div className="hp-pedigree-weatherbys__frameWrapper">
            <iframe
                className="hp-pedigree-weatherbys__frame"
                src={url}
                scrolling="no"
            />
        </div>
    </div>
);

WeatherbysFamilyTree.propTypes = {
    url: PropTypes.string,
};

export default WeatherbysFamilyTree;



// WEBPACK FOOTER //
// ./src/js/horse/pedigree/familyTree/WeatherbysFamilyTree.jsx